module.exports = __webpack_public_path__ + "static/media/tour1.df59a791.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour1.mp4
// module id = 296
// module chunks = 0